import { ChatCallType, ChatMessage } from "@web-src/modules/chats/types";
import { IAgoraRTCClient } from "agora-rtc-react";
import { createContext } from "react";
import { useActiveCall } from "../hooks/useActiveCall";
import { ActiveCallProps, CallStage } from "../types";

export interface CallsContextType {
  joinCall?: (params: {
    channel: string;
    callType?: ChatCallType;
    to?: string;
    isIncomingCall?: boolean;
  }) => void;
  leaveCall?: () => void;
  client?: IAgoraRTCClient;
  activeCall?: ReturnType<typeof useActiveCall>;
  incomingCall?: ChatMessage;
  callMsgId?: string;
  setIncomingCall?: React.Dispatch<
    React.SetStateAction<ChatMessage | undefined>
  >;
  videoDevices?: MediaDeviceInfo[];
  audioDevices?: MediaDeviceInfo[];
  playbackDevices?: MediaDeviceInfo[];
  activeCallProps?: ActiveCallProps;
  callStage?: CallStage;
  setCallStage?: React.Dispatch<React.SetStateAction<CallStage>>;
}

export const CallsContext = createContext<CallsContextType>({});
